var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBagniWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 159,
    viewBox: "0 0 270 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.69 89.45H252.97V134.92H232.99H232.91V88.78L136.79 25.33L100.83 48.65H64.39L136.27 0L269.69 89.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27 66.61C200.76 55.82 191.88 47.23 180.97 47.23C170.06 47.23 161.18 55.82 160.67 66.61H201.28H201.27Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63 78.9C172.541 78.9 174.09 77.3509 174.09 75.44C174.09 73.5291 172.541 71.98 170.63 71.98C168.719 71.98 167.17 73.5291 167.17 75.44C167.17 77.3509 168.719 78.9 170.63 78.9Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51 78.9C184.421 78.9 185.97 77.3509 185.97 75.44C185.97 73.5291 184.421 71.98 182.51 71.98C180.599 71.98 179.05 73.5291 179.05 75.44C179.05 77.3509 180.599 78.9 182.51 78.9Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38 78.9C196.291 78.9 197.84 77.3509 197.84 75.44C197.84 73.5291 196.291 71.98 194.38 71.98C192.469 71.98 190.92 73.5291 190.92 75.44C190.92 77.3509 192.469 78.9 194.38 78.9Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.01 88.06C165.921 88.06 167.47 86.5109 167.47 84.6C167.47 82.689 165.921 81.14 164.01 81.14C162.099 81.14 160.55 82.689 160.55 84.6C160.55 86.5109 162.099 88.06 164.01 88.06Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.89 88.06C177.801 88.06 179.35 86.5109 179.35 84.6C179.35 82.689 177.801 81.14 175.89 81.14C173.979 81.14 172.43 82.689 172.43 84.6C172.43 86.5109 173.979 88.06 175.89 88.06Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76 88.06C189.671 88.06 191.22 86.5109 191.22 84.6C191.22 82.689 189.671 81.14 187.76 81.14C185.849 81.14 184.3 82.689 184.3 84.6C184.3 86.5109 185.849 88.06 187.76 88.06Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69 88.06C201.601 88.06 203.15 86.5109 203.15 84.6C203.15 82.689 201.601 81.14 199.69 81.14C197.779 81.14 196.23 82.689 196.23 84.6C196.23 86.5109 197.779 88.06 199.69 88.06Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.11 134.46H217.75V49.9C217.75 40.94 210.46 33.64 201.5 33.64C192.54 33.64 185.24 40.93 185.24 49.9H176.88C176.88 36.33 187.92 25.29 201.49 25.29C215.06 25.29 226.1 36.33 226.1 49.9V134.47L226.11 134.46Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.12 123.25C39.12 130.32 33.28 134.47 22.3 134.47H0.219971V93.58H21.13C31.88 93.58 37.14 97.96 37.14 104.27C37.14 108.18 35.15 111.34 31.65 113.15C36.26 114.79 39.13 118.29 39.13 123.26L39.12 123.25ZM11.67 101.92V109.81H19.62C23.48 109.81 25.46 108.47 25.46 105.84C25.46 103.21 23.47 101.93 19.62 101.93H11.67V101.92ZM27.44 121.96C27.44 119.15 25.34 117.81 21.37 117.81H11.67V126.11H21.37C25.34 126.11 27.44 124.77 27.44 121.96Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54 126.52H55.25L52.04 134.47H40.24L58.29 93.58H69.68L87.79 134.47H75.76L72.54 126.52ZM69.15 117.99L63.89 104.9L58.63 117.99H69.15Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87 113.14H128.09V130.08C123.36 133.47 116.87 135.28 110.92 135.28C97.89 135.28 88.37 126.46 88.37 114.01C88.37 101.56 97.89 92.74 111.16 92.74C118.81 92.74 125 95.37 129.03 100.22L121.67 106.88C118.86 103.78 115.65 102.32 111.74 102.32C104.73 102.32 100.06 106.93 100.06 114C100.06 121.07 104.73 125.68 111.63 125.68C113.79 125.68 115.83 125.27 117.88 124.34V113.12L117.87 113.14Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36 93.57V134.46H164.84L146.79 112.67V134.46H135.45V93.57H144.97L163.02 115.36V93.57H174.35H174.36Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.54 93.57H194.1V134.46H182.54V93.57Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.62 58.66V86.09H19.7V73.86H3.95003V86.09H0.0300293V58.66H3.95003V70.45H19.7V58.66H23.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12 72.37C32.12 64.34 38.31 58.34 46.73 58.34C55.15 58.34 61.27 64.3 61.27 72.37C61.27 80.44 55.08 86.4 46.73 86.4C38.38 86.4 32.12 80.41 32.12 72.37ZM57.36 72.37C57.36 66.3 52.81 61.83 46.74 61.83C40.67 61.83 36.04 66.3 36.04 72.37C36.04 78.44 40.58 82.91 46.74 82.91C52.9 82.91 57.36 78.44 57.36 72.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54 74.25V58.65H73.46V74.09C73.46 80.16 76.24 82.91 81.18 82.91C86.12 82.91 88.94 80.17 88.94 74.09V58.65H92.74V74.25C92.74 82.2 88.39 86.4 81.14 86.4C73.89 86.4 69.54 82.21 69.54 74.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77 82.95L102.22 79.89C104.26 81.73 107.75 83.06 111.27 83.06C116.01 83.06 118.05 81.22 118.05 78.83C118.05 72.13 101.44 76.36 101.44 66.17C101.44 61.94 104.73 58.33 111.94 58.33C115.15 58.33 118.48 59.19 120.76 60.76L119.47 63.89C117.08 62.36 114.38 61.66 111.95 61.66C107.29 61.66 105.29 63.62 105.29 66.01C105.29 72.71 121.9 68.52 121.9 78.59C121.9 82.78 118.53 86.39 111.28 86.39C107.09 86.39 102.97 84.98 100.78 82.94L100.77 82.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.03 82.68V86.09H130.12V58.66H149.48V62.07H134.04V70.49H147.79V73.82H134.04V82.68H150.03Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269.69,
    height: 158.41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBagniWhite);
export default __webpack_public_path__ + "static/media/logo-bagni-white.6444e35d76778f3210ec80f97ecfa194.svg";
export { ForwardRef as ReactComponent };